/**
 * 正负双指标对比折线图验证配置
 * 为新 ValidationEngine 提供验证规则
 */

import type { ValidationConfig } from '../../../core/dataProcessor/types';

// 🆕 为新 ValidationEngine 导出的配置
export const positiveAndNegativeDoubleIndicatorComparisonLineValidationConfig: ValidationConfig = {
  fields: [
    { field: 'x', type: ['string', 'date'], required: true },
    { field: 'y', type: 'number', required: true },
    { field: 'y2', type: 'number', required: true }
  ],
  businessRules: [
    {
      name: 'pn-double-indicator-sufficient-data',
      validator: data => Array.isArray(data) && data.length > 1,
      message:
        'Positive and negative double indicator comparison line requires more than 1 data point for comparison',
      suggestion: 'Provide multiple data points to show comparison trends',
      // 推荐性建议，不影响图表渲染
      severity: 'warning'
    }
  ]
};
